import { API_PROMOTIONS_BO_URL } from 'src/services/utils';
import { authInterceptor } from 'src/auth/interceptor';
import config from 'src/config';
import axios from 'axios';

import { headers } from '../utils';

const isProduction = config.environment === 'production';

const apiPromotionsBFF = axios.create({
  baseURL: API_PROMOTIONS_BO_URL,
  timeout: 30000,
  headers: {
    [headers.CONTENT_TYPE]: 'application/json'
  }
});

apiPromotionsBFF.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    await authInterceptor.interceptErrorResponse(error, isProduction);
  }
);

apiPromotionsBFF.interceptors.request.use(
  async (config) => {
    await authInterceptor.interceptConfig(config);
    return config;
  },
  (error) => {
    !isProduction && console.error(`Error config interceptor request: ${error}`);
    Promise.reject(new Error(error));
  }
);

export default apiPromotionsBFF;
